import * as React from 'react';
import { createView, view } from '@sail/engine';
import { copyTokens } from './tokens';
import { columnPaddingVariants } from './ColumnPaddingVariants';
import { ROW_GAP_SIZES, helmTokens } from '../../theme';
import { css } from '@sail/ui';
const createFooterVariants = ()=>{
    const getSpaceValue = (size)=>{
        return helmTokens.layout.rowGap[size];
    };
    const footerRowGap = ROW_GAP_SIZES.reduce((acc, size)=>{
        acc[size] = css({
            rowGap: `${getSpaceValue(size)}`
        });
        return acc;
    }, {});
    const footerGap = ROW_GAP_SIZES.reduce((acc, size)=>{
        if (size === 'none') {
            acc[size] = css({
                marginTop: `${getSpaceValue(size)}`
            });
        } else {
            acc[size] = css({
                marginTop: `calc(${getSpaceValue(size)} - ${copyTokens.rowGap})`
            });
        }
        return acc;
    }, {});
    return {
        footerRowGap,
        footerGap
    };
};
const { footerRowGap, footerGap } = createFooterVariants();
export const CopyFooterLayout = createView(({ children, gap, rowGap, ...props })=>{
    return /*#__PURE__*/ React.createElement(view.footer, props, children);
}, {
    variants: {
        ...columnPaddingVariants,
        gap: footerGap,
        rowGap: footerRowGap
    },
    defaults: {
        gap: 'none',
        rowGap: 'medium',
        columnPaddingLeft: undefined,
        columnPaddingRight: undefined
    },
    css: {
        paddingLeft: `${copyTokens.columnPaddingLeft}`,
        paddingRight: `${copyTokens.columnPaddingRight}`
    },
    uses: [
        css({
            display: 'grid',
            gridAutoColumns: 'minmax(0, 1fr)'
        })
    ]
});

//# sourceMappingURL=CopyFooterLayout.js.map